import { atom } from "recoil";

export const pendingShipmentDetailUpdatedFlagState = atom<boolean>({
  key: "pendingShipmentDetailUpdatedFlagState",
  default: false,
});
